"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clipboardFilesToFileField = exports.clipboardFileToFile = void 0;
function clipboardFileToFile(clipboardValue, _srcField, _targetField, _userPreferences, currentValue) {
    const curFiles = currentValue || [];
    const newFiles = [];
    const currentHandles = curFiles.map((file) => file.handle);
    (clipboardValue.rawValue || []).forEach((file) => {
        if (!currentHandles.includes(file.handle)) {
            newFiles.push(file);
        }
    });
    return curFiles.concat(newFiles);
}
exports.clipboardFileToFile = clipboardFileToFile;
function clipboardFilesToFileField(clipboardValue, _srcField, _targetField, _userPreferences, currentValue, extra) {
    var _a, _b;
    if (!clipboardValue.files) {
        return currentValue;
    }
    return ((_b = (_a = extra.filesService) === null || _a === void 0 ? void 0 : _a.multiupload(clipboardValue.files)) !== null && _b !== void 0 ? _b : []);
}
exports.clipboardFilesToFileField = clipboardFilesToFileField;
